export default "__VITE_ASSET__a0d46a82__"